import React, { useState, useEffect } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth, getAppSettings, updateStatusForDate } from '../../api';
import { Text, Heading, VStack, Button, Box, Flex, Spacer } from '@chakra-ui/react';
import { Navigate, Link } from 'react-router-dom';
import { useAppSettings } from '../../contexts/app-settings-ctx';
import DateStatusSelector from './DateStatusSelector';
import ModalSpinner from '../../components/ModalSpinner';
import Footer from '../../components/Footer';

const formatDate = (date) => {
  const options = { weekday: 'long', month: 'short', day: 'numeric' };
  return new Intl.DateTimeFormat('it', options).format(new Date(date));
};

const pranzoCena = (date) => (new Date(date).getHours() < 16 ? 'pranzo' : 'cena');

function EventDates() {
  const [user] = useAuthState(auth);

  const [isLoading, setIsLoading] = useState();
  const { appSettings, setAppSettings, reset } = useAppSettings();
  // LOAD APP SETTINGS
  useEffect(() => {
    const _getAppSettings = async () => {
      setIsLoading(true);
      const settings = await getAppSettings();
      setAppSettings({ ...settings });
      setIsLoading(false);
    };
    reset(); // necessario perchè appSettings è globale e quindi la pagina viene renderizzata con il vecchio valore prima dello use effect 
    _getAppSettings();
  }, []);

  if (!user || user.displayName !== 'admin') return <Navigate to='/dashboard' replace={true} />;

  return (
    <VStack w='100%'>
      <Heading mt={5} mb={0} color={'white'}>
        Gestione date evento
      </Heading>

      <Text mb={3}>{process.env.REACT_APP_PROJECT_ID}</Text>
      <Button mb={3} as={Link} to='/dashboard'>
        Dashboard
      </Button>

      <VStack w={'100%'} border='0px solid teal' alignItems={'flex-start'}>
        {appSettings.eventDates.map((item) => {
          return (
            <Flex
              key={item.date.toString()}
              border='1px solid grey'
              borderRadius={15}
              p={3}
              w='100%'
            >
              <Text>
                {formatDate(item.date)} ({pranzoCena(item.date)})
              </Text>
              <Spacer />
              <DateStatusSelector
                initialValue={item.status}
                options={['open', 'closed', 'priority']}
                onChange={async (statusSelected) => {
                  // TODO: Non viene fatto error checking
                  await updateStatusForDate(item.date, statusSelected);
                }}
              />
            </Flex>
          );
        })}
        <Box>
          <Text fontSize={'xl'} mt={'25px'}>
            <b>Modalità</b>
          </Text>
          <Text fontSize={'md'} my={5}>
            <b>Open</b> Il catalogo è aperto per quella data, chiunque può effettuare ordini.
          </Text>
          <Text fontSize={'md'} my={5}>
            <b>Closed</b> Il catalogo è chiuso per quella data, nessuno può effettuare ordini.
          </Text>
          <Text fontSize={'md'} my={5}>
            <b>Priority</b> Sarà possibile effettuare un ordine per quella data solo se è già stato
            fatto un ordine la stessa data. Verifica tramite email.
          </Text>
        </Box>
      </VStack>
      <ModalSpinner isOpen={isLoading} />
      <Footer />
    </VStack>
  );
}
export default EventDates;
